const Contracts = () => import('./Contracts.vue')
const ContractDetails = () => import('./ContractDetails.vue')
const ContractInstallmentDetails = () => import('./ContractInstallmentDetails.vue')
export default [
  {
    name: 'contracts',
    path: 'contracts',
    component: Contracts,
    meta: {
      access: ['org.finance.contract.view']
    },
    children: [
      {
        name: 'contract',
        path: 'contract/:contractId',
        components: {
          modal: ContractDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.contract.view']
        }
      },
      {
        name: 'installment-edit',
        path: ':contractId/installment/:installmentId/edit',
        components: {
          modal: ContractInstallmentDetails
        },
        meta: {
          showModal: true,
          access: ['org.finance.contract.manage']
        }
      }
    ]
  }
]
